import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './AppWithGameFlow';
import reportWebVitals from './reportWebVitals';
import { fireLandingView } from './utils/analytics';
import { detectVariant } from './utils/variant';
import { captureInstallPrompt } from './utils/installPrompt';

captureInstallPrompt();
fireLandingView(detectVariant());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

if (process.env.REACT_APP_ITCH_BUILD !== 'true' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
